// extracted by mini-css-extract-plugin
export default {"productCarousel":"B0-z"};